export default __webpack_public_path__ + "static/media/active_star.0cd3dec5.svg";